import { City, CityLevel, UnitType, UnitCategory } from './types';
import { UNIT_DEFINITIONS, isAirborneUnit, isAircraft } from './unitDefinitions';

export function getCityMaxUnits(level: CityLevel): number {
  switch (level) {
    case CityLevel.OUTPOST:
      return 3;
    case CityLevel.FACTORY:
      return 5;
    case CityLevel.AIRBASE:
      return 8;
    default:
      return 3;
  }
}

export function getCityUpgradeCost(toLevel: CityLevel): number {
  switch (toLevel) {
    case CityLevel.FACTORY:
      return 25;
    case CityLevel.AIRBASE:
      return 50;
    default:
      return 0;
  }
}

export function getCityUpgradeTime(toLevel: CityLevel): number {
  switch (toLevel) {
    case CityLevel.FACTORY:
      return 2;
    case CityLevel.AIRBASE:
      return 3;
    default:
      return 0;
  }
}

export function canCityTrainUnit(city: City, unitType: UnitType): boolean {
  const unitDef = UNIT_DEFINITIONS[unitType];
  if (!unitDef) return false;

  const category = unitDef.category;
  
  // Aircraft and airborne units require Level 3 (Airbase)
  if (isAirborneUnit(unitType) || isAircraft(unitType)) {
    return city.level === CityLevel.AIRBASE;
  }

  // Level 1 (Outpost) - Only basic infantry (non-airborne), engineers, medics
  if (city.level === CityLevel.OUTPOST) {
    return category === UnitCategory.INFANTRY || 
           category === UnitCategory.ENGINEERS || 
           category === UnitCategory.MEDICS;
  }

  // Level 2 (Factory) - Add tanks, artillery, reconnaissance, halftracks, transports
  if (city.level === CityLevel.FACTORY) {
    return category === UnitCategory.INFANTRY || 
           category === UnitCategory.ENGINEERS || 
           category === UnitCategory.MEDICS ||
           category === UnitCategory.ARMOR ||
           category === UnitCategory.ARTILLERY ||
           category === UnitCategory.RECONNAISSANCE ||
           category === UnitCategory.HALFTRACK ||
           category === UnitCategory.TRANSPORT;
  }

  // Level 3 (Airbase) - Can train everything
  if (city.level === CityLevel.AIRBASE) {
    return true;
  }

  return false;
}

export function getCityLevelName(level: CityLevel): string {
  switch (level) {
    case CityLevel.OUTPOST:
      return 'Outpost';
    case CityLevel.FACTORY:
      return 'Factory';
    case CityLevel.AIRBASE:
      return 'Airbase';
    default:
      return 'Unknown';
  }
}

export function getCityLevelDescription(level: CityLevel): string {
  switch (level) {
    case CityLevel.OUTPOST:
      return 'Can train basic infantry, engineers, and medics';
    case CityLevel.FACTORY:
      return 'Can also train tanks, artillery, and vehicles';
    case CityLevel.AIRBASE:
      return 'Can train all units including aircraft and airborne';
    default:
      return '';
  }
}

export function getCityResourceGeneration(level: CityLevel): number {
  switch (level) {
    case CityLevel.OUTPOST:
      return 5;
    case CityLevel.FACTORY:
      return 10;
    case CityLevel.AIRBASE:
      return 15;
    default:
      return 5;
  }
}